import { render, staticRenderFns } from "./PasswordRecoveryVerify.vue?vue&type=template&id=cc212ca8&scoped=true&"
import script from "./PasswordRecoveryVerify.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryVerify.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecoveryVerify.vue?vue&type=style&index=0&id=cc212ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc212ca8",
  null
  
)

/* custom blocks */
import block0 from "./PasswordRecoveryVerify.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc212ca8')) {
      api.createRecord('cc212ca8', component.options)
    } else {
      api.reload('cc212ca8', component.options)
    }
    module.hot.accept("./PasswordRecoveryVerify.vue?vue&type=template&id=cc212ca8&scoped=true&", function () {
      api.rerender('cc212ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/authentication/PasswordRecoveryVerify.vue"
export default component.exports